import { styled, Box } from "@mui/material";

const NavbarWrapper = styled(Box)(({ theme }) => ({
  color: theme.palette.widgetStyles.navbar.textColor,
  backgroundColor: theme.palette.widgetStyles.navbar.backgroundColor,
}));

export default NavbarWrapper;
